import {NumericFormat} from 'react-number-format';
import TextField from "@mui/material/TextField";
import './formGenerator.css'

const NumberInput = ({
                         field,
                         value,
                         onChange,
                         error,
                         helperText,
    disabled,
                     }) => {
    return (
        <NumericFormat
            className="textfield-outline"
            variant='outlined'
            customInput={TextField}
            fullWidth
            required={field.required}
            placeholder={field.placeholder}
            thousandSeparator=","
            value={value ?? ""}
            onValueChange={(values) => {
                onChange(field.id, values.value === "" ? "" : values.floatValue);
            }}
            error={error}
            helperText={helperText}
            InputProps={{
                inputProps: {
                    min: field.min,
                    max: field.max,
                    step: field.step ?? 1
                }
            }}
            disabled={disabled}
        />
    );
};

export default NumberInput;
